import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdvancedStatsPromoState {
	hasSeenPromo: boolean;
	setHasSeenPromo: (hasSeen: boolean) => void;
	clearPromoState: () => void;
}

export const useAdvancedStatsPromoStore = create<AdvancedStatsPromoState>()(
	persist(
		(set) => ({
			hasSeenPromo: false,
			
			setHasSeenPromo: (hasSeen: boolean) => {
				set({ hasSeenPromo: hasSeen });
			},
			clearPromoState: () => {
				set({ hasSeenPromo: false });
			},
		}),
		{
			name: 'advanced-stats-promo-storage',
		}
	)
); 